<template>
  <div class="chat_room_estimation_item_wrap" v-if="fetchCompleted">
    <div class="chat_room_estimation_item">
      <div class="estimation_top">
        <div class="est_title">
          휴대폰 견적을 요청합니다!
        </div>
        <div class="est_date">작성일: {{ item.createdAt }}</div>
      </div>
      <div class="estimation_con">
        <div class="con_list list_pd">
          <div class="list_title">구매대상</div>
          <div class="list_txt">
            {{ convertCodeToName(item.target, TARGET_NAME_ENUM) }}
          </div>
        </div>
        <div class="con_list list_pd">
          <div class="list_title">단말기</div>
          <div class="list_txt">{{ item.needModelName }}</div>
        </div>
        <div class="con_list">
          <div class="list_title">현재 이용 내역</div>
          <div class="list_txt" style="white-space: nowrap;">
            {{ item.telecomName }} /
          </div>
        </div>
        <div class="con_list list_pd">
          <div class=""></div>
          <div class="list_txt">{{ currentModelName }}</div>
        </div>
        <div class="con_list list_pd">
          <div class="list_title">통신사 변경 의향</div>
          <div class="list_txt">
            {{
              convertCodeToName(item.telecomMaintance, TELECOM_MAINTANCE_ENUM)
            }}
          </div>
        </div>
        <div class="con_list list_pd">
          <div class="list_title">월 납부액</div>
          <div class="list_txt">
            {{ convertCodeToName(item.dataUsage, DATA_USAGE_ENUM) }}
          </div>
        </div>
        <div class="con_list">
          <div class="list_title">이용중인 인터넷</div>
          <div class="list_txt">
            {{ convertCodeToName(item.internetUsage, INTERNET_USAGE_ENUM) }}
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn bo"
      @click.stop.prevent="openQuotation()"
      v-if="!isCustomer"
    >
      견적서 보내기
    </button>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import {
  mapActions as mapEstimateActions,
  mapGetters as mapEstimateGetters,
  mapMutations as estimateMapMutations,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';

export default {
  props: {
    EstimationId: Number,
    chatroom: Object,
    isCustomer: Boolean,
  },
  async created() {
    await this.estimationData();
  },
  data() {
    return {
      item: null,
      fetchCompleted: false,
      TARGET_NAME_ENUM: [
        { value: 1, name: '본인' },
        { value: 2, name: '부' },
        { value: 3, name: '모' },
        { value: 4, name: '자녀' },
      ],
      TELECOM_MAINTANCE_ENUM: [
        { value: 1, name: '네' },
        { value: 2, name: '아니오' },
        { value: 3, name: '모르겠음' },
      ],
      DATA_USAGE_ENUM: [
        { value: 1, name: '6만 원이상' },
        { value: 2, name: '4~5만 원대' },
        { value: 3, name: '3만 원대' },
        { value: 4, name: '3만 원 미만' },
        { value: 5, name: '모르겠음' },
      ],
      INTERNET_USAGE_ENUM: [
        { value: 1, name: 'SKB' },
        { value: 2, name: 'KT' },
        { value: 3, name: 'LGU' },
        { value: 4, name: '지역방송' },
        { value: 5, name: '모르겠음' },
        { value: 6, name: '이용안함' },
      ],
    };
  },
  computed: {
    ...mapEstimateGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
      quotation: estimationTypes.QUOTATION,
    }),
    currentModelName() {
      return this.item.currentModelName || '잘 모르겠음';
    },
  },
  mounted() {
    //alert(this.bookingModel);
  },
  methods: {
    ...mapEstimateActions([
      estimationTypes.FETCH_ESTIMATION,
      estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS,
      estimationTypes.FETCH_LATELY_ESTIMATION,
      estimationTypes.ESTIMATION_MODEL_RESET_STATE,
    ]),
    ...estimateMapMutations([
      estimationTypes.SET_QUOTATION,
      estimationTypes.QUOTATION_RESET_STATE,
    ]),
    async estimationData() {
      const data = await this[estimationTypes.FETCH_ESTIMATION]({
        id: this.EstimationId,
      });
      this.item = data;
      this.fetchCompleted = true;
    },
    convertCodeToName(value, type) {
      if (value) {
        return type.find(d => d.value === value).name;
      }
    },
    async openQuotation() {
      this[estimationTypes.QUOTATION_RESET_STATE]();
      const customer = this.chatroom.chatMembers.find(
        m => m.user.roles !== '21',
      );
      const data = await this[estimationTypes.FETCH_LATELY_ESTIMATION]({
        userId: customer.userId,
        storeId: this.chatroom.store.id,
      });
      if (data) {
        this.quotation.estimateId.push(data.id);
        this.quotation.estimateSendView.push(data.sendView);
      } else {
        this.quotation.estimateId.push(0);
        this.quotation.estimateSendView.push('');
      }
      this.quotation.userId.push(customer.userId);
      this.quotation.storeName = this.chatroom.store.name;
      this.quotation.isFromChat = true;

      await this[estimationTypes.SET_QUOTATION](this.quotation);
      this.$router.push({
        name: 'Estimation.SendQuotation',
        params: {
          uuid: this.chatroom.uuid,
          storeId: this.chatroom.store.id,
          customerId: customer.userId,
        },
      });
    },
  },
};
</script>

<style></style>
